import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import{
  CATEGORY_CHANGE_SUBCOMMITTEE,
  DELETE_SUBCOMMITTEE_MEMBER
} from 'manager/http-constants';
import {
  API_RESPONSE,
} from 'src/app/shared/constant/api-constant';
import { CONSTANT, LOADING_KEY } from 'src/app/shared/constant/constant';
import { MESSAGE_CODE } from 'src/app/shared/constant/message-constant';
import { TOAST } from 'src/app/shared/constant/primeng-constants';
import {
  LoadData,
  LoadingState,
} from 'src/app/shared/html-parts/loading/loading-state';
import {
  MessageData,
  ToastMessageData,
} from 'src/app/shared/html-parts/message-common/message-data';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { PlatformComponent } from '../../platform.component';

@Component({
  selector: 'app-subcommittee-dialog',
  templateUrl: './subcommittee-dialog.component.html',
  styleUrls: ['./subcommittee-dialog.component.scss'],
})

/**
 * 共通部品_分科会用ダイアログ
 */
export class SubcommitteeDialogComponent extends PlatformComponent {

  // 変更結果返却 (true:変更成功,false:変更失敗)
  @Output() returnChange = new EventEmitter<boolean>();

  // 区分変更ダイアログ表示フラグ(true=非表示,false=表示)
  categoryChangeFlag: boolean = false;

  // 退会ダイアログ表示フラグ(true=非表示,false=表示)
  withdrawalFlag: boolean = false;

  // 分科会ID
  subcommitteeId: string;

  // 文言表示用メンバー区分
  memberKbnId: string;

  // メンバーID
  userId: string;

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private messageData: MessageData
  ) {
    super(route, commonService, dbOperationService, loadingState);
  }

  ngOnInit(): void {}

  /**
   * 区分変更ダイアログ表示
   * @param pkeyId 対象データのID
   * @param memberKbnId メンバー区分
   * @param userId ユーザID
   */
  public openCategoryChange(
    pkeyId: string,
    memberKbnId: string,
    userId: string
  ): void {
    // 区分変更ダイアログが既に表示済みの場合
    if (this.categoryChangeFlag) {
      // 処理を終了
      return;
    }

    // 各クラス変数に格納
    this.subcommitteeId = pkeyId;
    this.userId = userId
    this.memberKbnId = memberKbnId;

    // 区分変更ダイアログ表示
    this.categoryChangeFlag = true;
  }

  /**
   * 退会ダイアログ表示
   * @param pkeyId 対象データのID
   * @param userId ユーザID
   */
   public openWithdrawal(
    pkeyId: string
  ): void {
    // 退会ダイアログが既に表示済みの場合
    if (this.withdrawalFlag) {
      // 処理を終了
      return;
    }

    // 各クラス変数に格納
    this.subcommitteeId = pkeyId;
    this.userId = this.loginUser.user_id

    // 退会ダイアログ表示
    this.withdrawalFlag = true;
  }

  /**
   * 退会実施
   * @param pkeyId 対象データのID
   * @param memberKbnId メンバー区分
   * @param userId ユーザID
   */
   public doWithdrawal(): void {

    this.dbOperationService
      .deleteDataByQueryparam(DELETE_SUBCOMMITTEE_MEMBER, {"subcommittee_id": this.subcommitteeId, "user_id": this.userId})
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_UPDATE);

        // レスポンス結果を判定
        if (API_RESPONSE.SUCCESS == response.body.Message) {
          // 正常終了の場合

          // 退会ダイアログ非表示
          this.withdrawalFlag = false;

          // 退会変更完了
          this.returnChange.emit(true);
        } else {
          // 異常終了の場合

          // 異常終了メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.ERROR,
              summary: this.commonService.msg(MESSAGE_CODE.E00001),
              detail: this.commonService.msg(MESSAGE_CODE.E80002),
            })
          );

          // 退会ダイアログ表示
          this.withdrawalFlag = false;
        }
      });
  }

  /**
   * 区分変更実施
   */
  public updateChange(): void{

    this.dbOperationService
      .updateData(CATEGORY_CHANGE_SUBCOMMITTEE, this.userId, {"subcommittee_id": this.subcommitteeId})
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_UPDATE);

        // レスポンス結果を判定
        if (API_RESPONSE.SUCCESS == response.body.Message) {
          // 正常終了の場合

          // 区分変更ダイアログ非表示
          this.categoryChangeFlag = false;

          // 区分変更完了
          this.returnChange.emit(true);
        } else {
          // 異常終了の場合

          // 異常終了メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.ERROR,
              summary: this.commonService.msg(MESSAGE_CODE.E00001),
              detail: this.commonService.msg(MESSAGE_CODE.E80002),
            })
          );

          // 確認画面表示フラグ
          this.categoryChangeFlag = false;
        }
      });
  }

  public closeDialog(): void {
    this.categoryChangeFlag = false;
    this.withdrawalFlag = false;
  }
}
